import axiosInstance from "./api_helper";

export const createSale = async (saleData) => {
  try {
    const response = await axiosInstance.post('/api/sales', JSON.stringify(saleData));
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateSale = async (id, saleData) => {
  try {
    const response = await axiosInstance.put(`/api/sales/${id}`, JSON.stringify(saleData));
    return response;
  } catch (error) {
    throw error;
  }
}

export const generateInvoice = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/sales/invoice/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const search = async (query) => {
  return axiosInstance.post(`/api/sales/search`, JSON.stringify(query));
};

export const getSales = async (page = 1, size = 10) => {
  try {
    const response = await axiosInstance.get('/api/sales', {
      params: { page: page - 1, size }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSalesData = (dateRange) => axiosInstance.get(`/api/ventes/dashboard?dateRange=${dateRange}`);
export const getSalesReport = (dateRange) => axiosInstance.get(`/api/sales/dashboard/report?dateRange=${dateRange}`);
export const getSaleById = async (id) => {
  try {
    const response = await axiosInstance.get(`/api/sales/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const downloadBill = async (id) => {
  return axiosInstance.get(`/api/sales/bill/${id}`);
};

export const cancelSale = async (id) => {
  try {
    const response = await axiosInstance.post(`/api/sales/${id}/cancel`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSalesByDateRange = async (startDate, endDate, page = 1, size = 10) => {
  try {
    const response = await axiosInstance.get('/api/sales/search', {
      params: {
        startDate,
        endDate,
        page: page - 1,
        size
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTotalSalesToday =  async () => {
  return axiosInstance.get(`/api/sales/total-sales/today`);
};

export const getTotalSalesThisWeek = async () => {
  return axiosInstance.get(`/api/sales/total-sales/this-week`);
};

export const getTotalSalesThisMonth = async () => {
  return axiosInstance.get(`/api/sales/total-sales/this-month`);
};

export const getTotalSalesThisYear = async () => {
  return axiosInstance.get(`/api/sales/total-sales/this-year`);
};

export const getTotalSalesForDateRange = async (startDate, endDate) => {
  return axiosInstance.get(`/api/sales/total-sales`, {
      params: {
          startDate: startDate,
          endDate: endDate
      }
  });
}